export default __webpack_public_path__ + "static/media/img-slider-urban-fund-2.323688f1.png";